export const userRoles = {
  admin: {
    description: 'Admins can create and manage teams, they can also lead teams, run Squizzes, and view all analytics.'
  },
  teamLeader: {
    description: 'Team Leaders can run Squizzes, view analytics, and manage their teams. Teams can have multiple team leaders.'
  }
}